import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';
import 'select2_overrides.scss';

const formatState = state => {
  if (!state.id) {
    return state.text;
  }
  return $(
    `<span><img src="//s3.amazonaws.com/assets.zenpayroll.com/static/images/flags/${state.element.value.toLowerCase()}.png" class="img-flag" /> ${
      state.text
    }</span>`
  );
};

$('.js-load-select2-states')
  .not('.select2-hidden-accessible')
  .select2({
    placeholder: 'Select a State',
    templateResult: formatState,
    templateSelection: formatState,

    matcher(params, data) {
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // display state only if it's matched from beginning of the string
      if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) === 0) {
        return data;
      }

      return null;
    },
  });

// Manually add an aria-label to the Select2 input field for accessibility
$('.select2-search__field').attr('aria-label', 'States');
